import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import ConsoleStore from '../../stores/ConsoleStore';
import FuseUserMenu from './FuseUserMenu';
import ChangePasswordModal from './ChangePasswordModal';
import FuseConsoleCustomerSelect from './FuseConsoleCustomerSelect';
import FuseButton from '../FuseControls/FuseButton';
import ConsoleCustomerSelectStore from '../../stores/ConsoleCustomerSelectStore';
import AppSwitcher from '../FuseControls/AppSwitcher';
import { LogoProofpointWord } from '../Logo/PfptLogo';
import './FuseConsoleTopBar.css';

const block = b.lock('FuseConsoleTopBar');

const PENDO_RESOURCE_CENTER_CONTAINER_ID = 'pendo-resource-center-container';
const PENDO_RESOURCE_CENTER_BUTTON_ID = 'pendo-center';

class FuseConsoleTopBar extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        customerSelect: ConsoleCustomerSelectStore.PropType.isRequired,
    };

    state = {
        pendoButtonActive: false,
    }

    componentDidMount() {
        document.body.addEventListener('click', this.onBodyClick);
        this.observer = new window.MutationObserver(() => {
            const isPendoResourceCenterOpen = !!document.getElementById(PENDO_RESOURCE_CENTER_CONTAINER_ID);
            if (!isPendoResourceCenterOpen) {
                this.blurPendoButton();
            }
            this.setState({ pendoButtonActive: isPendoResourceCenterOpen });
        });
        this.observer.observe(document.body, { childList: true });
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onBodyClick);
        this.observer.disconnect();
    }

    onBodyClick = (event) => {
        const pendoResourceCenterContainer = document.getElementById(PENDO_RESOURCE_CENTER_CONTAINER_ID);
        const pendoResourceCenterButton = document.getElementById(PENDO_RESOURCE_CENTER_BUTTON_ID);

        if (pendoResourceCenterContainer &&
            !pendoResourceCenterContainer.contains(event.target) &&
            !pendoResourceCenterButton?.contains(event.target)
        ) {
            pendoResourceCenterButton.click();
        }
    }

    onUserIconClick = (event) => {
        event.stopPropagation();
        const { console, customerSelect } = this.props;
        if (customerSelect.dropdown.isOpen) {
            customerSelect.dropdown.close();
            console.userMenu.open();
        } else {
            console.userMenu.toggle();
        }
    };

    blurPendoButton = () => {
        const pendoResourceCenterButton = document.getElementById(PENDO_RESOURCE_CENTER_BUTTON_ID);
        pendoResourceCenterButton.blur();
    }

    render() {
        const { console } = this.props;

        return <div className={block()}>
            <AppSwitcher store={console.appSwitcher} />
            <div className={block('Logo')}>
                <LogoProofpointWord
                    wordClassName={block('LogoWord')}
                    mainColor={'white'}
                    style={{
                        width: 98,
                        height: 20,
                        display: 'block',
                    }}
                />
            </div>
            <div className={block('AppName')}>Isolation</div>
            <div className={block('Spacer')} />
            <div className={block('Company')}>
                <FuseConsoleCustomerSelect />
            </div>
            <FuseButton
                id={PENDO_RESOURCE_CENTER_BUTTON_ID}
                className={block('PendoButton', { active: this.state.pendoButtonActive })}
                icon="campaign"
                onClick={this.blurPendoButton}
            />
            <div className={block('UserMenuWrapper')}>
                <FuseButton
                    qa={'account-cta'}
                    className={block('UserMenuButton', { active: console.userMenu.isOpen })}
                    icon="account_circle"
                    onClick={this.onUserIconClick}
                />
                {console.userMenu.isOpen ? <FuseUserMenu /> : null}
                <ChangePasswordModal />
            </div>
        </div>;
    }
}

export default inject('console', 'customerSelect')(observer(FuseConsoleTopBar));
